let ROOT_URL = "";
let IMAGE_URL = "";
let WEB_URL = "";
let BEAM_URL = "https://bs.tcgdob.com/api";

ROOT_URL = "https://api.tcgdob.com/api/v1";
WEB_URL = "https://tcgdob.com";

export { IMAGE_URL, WEB_URL, BEAM_URL };
export default ROOT_URL;

